import React from 'react';
import { FoodPhoto } from '../FoodPhoto';
export function FoodPhoto4() {
  return <FoodPhoto src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&q=85" alt="Fresh meal prep with colorful ingredients" caption="Weekly meal prep with lean proteins, whole grains, and fresh produce" data-id="element-665" data-mp="14bpoahlv4qpz" />;
}